import axios from 'axios';
import { API_CONFIG } from '../config/env';
import { unwrapApiData } from '../utils/apiResponse';
import { getAccessToken } from '../utils/auth';

function normalizeTelegramId(item: unknown): string | null {
  if (typeof item === 'string' && item.trim()) return item.trim();
  if (typeof item === 'number' && Number.isFinite(item)) return String(item);
  if (item && typeof item === 'object') {
    const o = item as Record<string, unknown>;
    for (const key of ['telegramId', 'TelegramId', 'id']) {
      const v = o[key];
      if (typeof v === 'string' && v.trim()) return v.trim();
      if (typeof v === 'number' && Number.isFinite(v)) return String(v);
    }
  }
  return null;
}

function parseTelegramIdList(payload: unknown): string[] {
  const inner = unwrapApiData<unknown>(payload) ?? payload;
  if (!Array.isArray(inner)) return [];
  const ids = inner.map(normalizeTelegramId).filter((id): id is string => Boolean(id));
  return Array.from(new Set(ids));
}

class TelegramAccountsService {
  private getAuthHeaders() {
    const token = getAccessToken();
    return {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json',
    };
  }

  async getTelegramAccounts(): Promise<string[]> {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/telegram-users`, {
      headers: this.getAuthHeaders(),
    });
    return parseTelegramIdList(response.data);
  }

  async addTelegramAccount(telegramId: string): Promise<void> {
    await axios.post(`${API_CONFIG.BASE_URL}/telegram-users/${telegramId}`, {}, {
      headers: this.getAuthHeaders(),
    });
  }

  async deleteTelegramAccount(telegramId: string): Promise<void> {
    await axios.delete(`${API_CONFIG.BASE_URL}/telegram-users/${telegramId}`, {
      headers: this.getAuthHeaders(),
    });
  }
}

export const telegramAccountsService = new TelegramAccountsService();
